/**
 * Use BUS_ASSET_COVER_IMAGES's type directly if you want TS to strictly infer the valid keys
 */
export type BusAssetCoverImagesLoose = Readonly<
    Record<
        string,
        Readonly<{
            name: string;
            position: number;
            position_admin: number;
            label: string;
            group: string;
            description: string;
            performTextInpaint: boolean;
        }>
    >
>;

export const BUS_ASSET_COVER_IMAGES = {
    photo_cover_base: {
        name: 'photo_cover_base',
        position: 2000,
        position_admin: 2000,
        label: 'Base cover photo',
        group: 'cover',
        description: 'The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)',
        performTextInpaint: true,
    },
    photo_cover_hover: {
        name: 'photo_cover_hover',
        position: 2010,
        position_admin: 2010,
        label: 'Hover cover photo',
        group: 'cover',
        description: 'The photo usually on mouse hover in the listing page, (default: photo_front)',
        performTextInpaint: true,
    },
} as const satisfies BusAssetCoverImagesLoose;
